<template>
    <canvas :width="width" :height="height" class="canvas"></canvas>
</template>

<style>
    .canvas {
        width: 100%;
    }


</style>

<script>
    export default {
        name: "CandleStick",
        props: ['stock'],
        data: () => ({
            width: 200,
            //width: 13,
            height: 13,
            ctx: null,
            p1H: 0,
            middle: 0,
            options: {
                margin: 10,
                lineWidth: 1,
                candleColorB: '#002bff',
                candleColorS: '#fd1717',
            },
            candleData: [],
        }),
        watch: {
            stock() {
                const { highRate, lowRate, openingRate, rate } = this.stock;
                this.cleanData();
                this.setData([
                    {
                        l: Number(lowRate),
                        h: Number(highRate),
                        o: Number(openingRate),
                        c: Number(rate)
                    }
                ]);
                this.verticalDraw();
            }
        },
        methods: {
            draw() {
                this.ctx.clearRect(0, 0, this.width, this.height);
                const wP = this.width / this.candleData.length;

                this.candleData.forEach((el, i) => {
                    this.ctx.strokeStyle =
                        el.c > el.o
                            ? this.options.candleColorB
                            : el.c < el.o
                            ? this.options.candleColorS
                            : "white";

                    let x = i * (this.width / this.candleData.length);
                    x += this.width / this.candleData.length / 2;

                    let yO = this.candleData[i].o;
                    let yC = this.candleData[i].c;

                    this.ctx.lineWidth = (wP / 100) * this.options.lineWidth;

                    yC = yO === yC ? yC + this.ctx.lineWidth : yC;
                    this.ctx.beginPath();
                    this.ctx.moveTo(x, this.candleData[i].h);
                    this.ctx.lineTo(x, this.candleData[i].l);
                    this.ctx.stroke();

                    this.ctx.lineWidth = (wP / 100) * (100 - this.options.margin);
                    this.ctx.beginPath();
                    this.ctx.moveTo(x, yO);
                    this.ctx.lineTo(x, yC);
                    this.ctx.stroke();
                });
            },
            verticalDraw() {
                this.ctx.clearRect(0, 0, this.width, this.height);
                const wP = this.width / this.candleData.length;

                this.candleData.forEach((el, i) => {

                    this.ctx.strokeStyle =
                        el.c < el.o
                            ? this.options.candleColorB
                            : el.c > el.o
                            ? this.options.candleColorS
                            : el.originC >= 0 ? this.options.candleColorB : this.options.candleColorS;

                    let x = i * (this.width / this.candleData.length);
                    x += this.width / this.candleData.length / 2;

                    let y = i * (this.height / this.candleData.length);
                    y += this.height / this.candleData.length / 2;

                    let yO = this.candleData[i].o;
                    let yC = this.candleData[i].c;

                    this.ctx.lineWidth = (wP / 100) * this.options.lineWidth;

                    yC = yO === yC ? yC + this.ctx.lineWidth : yC;

                    this.ctx.beginPath();
                    this.ctx.moveTo(this.candleData[i].l, y);
                    this.ctx.lineTo(this.candleData[i].h, y);
                    this.ctx.stroke();

                    this.ctx.lineWidth = 8;
                    this.ctx.beginPath();
                    this.ctx.moveTo(yC, y);
                    this.ctx.lineTo(yO, y);
                    this.ctx.stroke();
                });

                this.ctx.beginPath();
                this.ctx.strokeStyle = "#000000";
                this.ctx.moveTo(this.middle, 0);
                this.ctx.lineTo(this.middle, 20);
                this.ctx.lineWidth = 1;
                this.ctx.stroke();
            },
            formatting(data) {
                let max = 30,
                    min = -30,
                    stat,
                    p1;

                data.forEach(el => {
                    // Находим максимальную цену
                    max = el.h > max ? el.h : max;
                    // Находим минимальную цену
                    min = !min || el.l < min ? el.l : min;
                });

                // Разница между максимальной и минимальной ценой
                stat = max - min;
                // Один процент от разницы максимальной и минимальной цены
                p1 = stat / 100;

                // Основной расчет позиций свечей.
                data = data.map(el => {
                    return {
                        l: this.width - ((100 - (stat - (max - el.l)) / p1) * this.p1H),
                        h: this.width - ((100 - (stat - (max - el.h)) / p1) * this.p1H),
                        o: this.width - ((100 - (stat - (max - el.o)) / p1) * this.p1H),
                        c: this.width - ((100 - (stat - (max - el.c)) / p1) * this.p1H),
                        originC: el.c,
                    };
                });

                this.middle = this.width - ((100 - (stat - max) / p1) * this.p1H)

                return data;
            },
            setData(data) {
                this.candleData = this.candleData.concat(this.formatting(data));
            },
            // Delete all chart data
            cleanData() {
                this.candleData = [];
            }
        },
        mounted() {
            // mounted 이후부터 canvas의 DOM에 접근할 수 있습니다.
            // CreateJS 등을 사용할 때에도 여기에서 canvas를 매개 변수로 전달해야 합니다.
            // console.log(this.$el)
            this.ctx = this.$el.getContext('2d');
            //this.p1H = this.height / 100;
            this.p1H = this.width / 100;

            const { highRate, lowRate, openingRate, rate } = this.stock;

            this.setData([
                {
                    l: Number(lowRate),
                    h: Number(highRate),
                    o: Number(openingRate),
                    c: Number(rate)
                }
            ]);

            this.verticalDraw();
            //this.draw();

        }
    }
</script>

<style scoped>

</style>
